.dropdowns {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: var(--bi-scale-8x);
}

.trigger {
    --bic-button-padding-inline: var(--bi-scale-4x);
}

/* Pushes the selected-count badge and the chevron to the far end of the full-width trigger. */
.triggerLabel {
    flex: 1;
    text-align: start;
}

/* .bi-popover caps itself at 300px, too narrow for the longer study names. */
.panel {
    --bic-popover-max-width: none;

    min-width: 22rem;
    max-width: min(28rem, 90vw);
    max-height: 60vh;
    overflow-y: auto;
}
